<app-menu-toggle
  tooltip="Overlay view"
  icon="overlay"
  [active]="showOverlay"
  (click)="toggleOverlay()"
>
</app-menu-toggle>
